import { createSlice, createAsyncThunk ,current} from "@reduxjs/toolkit";
import axios from "axios";
import { myHeaders } from "./CommonHeader";
import { UpdateCustomerStatus } from "./UpdateCustomerStatusRedux";

export const SendCustomerOrdersAction = createAsyncThunk(
    "SendCustomerOrdersAction",
    async (data1, { rejectWithValue }) => {
        try {
            const { data } = await axios.post(
                process.env.REACT_APP_BackEndIP + "/CustomerOrderAction",
                {
                    Action: data1[0],
                    OrderNo: data1[1],
                },
                {
                    headers: myHeaders(),
                }
            );
            return data;
        } catch (error) {
            console.error("!!!", error);
            if (error?.response?.status > 399 || error.code === "ERR_NETWORK") {
                localStorage.clear();
                window.location.assign("/");
            }
        }
    }
);

const CustomerOrdersSlice = createSlice({
    name: "CustomerOrders",
    initialState: {
        isLoading: "hide",
        isEmpty: "hide",
        isFilled: "",
        data: [],
        isError: "hide",
    },

    extraReducers: (builder) => {
        builder
            .addCase(SendCustomerOrdersAction.fulfilled, (state, action) => {
                state.isLoading = "hide";
                state.isEmpty = "hide";
                state.isFilled = "";
                if (action.payload === "[NoDataFound]") {
                    state.data = [];
                    state.isEmpty = "";
                    state.isFilled = "hide";
                } else {
                    // console.log(action.payload);
                    state.data = action.payload;
                }
                state.isError = "hide";
            })
            .addCase(SendCustomerOrdersAction.pending, (state, action) => {
                state.isLoading = "";
                state.isEmpty = "hide";
                state.isFilled = "";
                state.isError = "hide";
            })
            .addCase(SendCustomerOrdersAction.rejected, (state, action) => {
                state.isError = "";
                state.isEmpty = "hide";
                state.isFilled = "";
                state.isLoading = "hide";
            })
            .addCase(UpdateCustomerStatus.fulfilled, (state, action) => {
                let tmpData = [];
                console.log(action.payload)
                console.log(current(state.data))
                for (let i = 0; current(state.data).length > i; i++) {
                    // console.log("IN LOOP")
                    if (current(state.data)[i]["OrderNo"] != action.payload["OrderNo"]) {
                        tmpData.push(current(state.data)[i]);
                    } else {
                        let tmp2 = {};
                        for (const [key, value] of Object.entries(current(state.data)[i])) {
                            tmp2[key] = value;
                        }
                        if (action.payload["Update"] == "OrderStatus") {
                            tmp2["OrderStatus"] = action.payload["Data"];
                        }
                        else if (action.payload["Update"] == "PaymentStatus") {
                            tmp2["PaymentStatus"] = action.payload["Data"];
                        };
                        tmpData.push(tmp2);
                    }
                }
                console.log(tmpData)
                state.data = tmpData;
            });
    },
});

export default CustomerOrdersSlice.reducer;
